export const recaptchaId = {
    loginCheckbox: 'LoginCheckbox',
    loginScore: 'LoginScore',
    loginDrawerCheckbox: 'LoginDrawerCheckbox',
    loginDrawerScore: 'LoginDrawerScore',
    resetPasswordCheckbox: 'ResetPasswordCheckbox',
    resetPasswordScore: 'ResetPasswordScore',
    giftCard: 'GiftCard',
};
